/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} BleedInputs */

const en_bleed = /** @type {(inputs: BleedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bleed`)
};

const es_bleed = /** @type {(inputs: BleedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sangrado`)
};

const fr_bleed = /** @type {(inputs: BleedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fond perdu`)
};

const de_bleed = /** @type {(inputs: BleedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anschnitt`)
};

const ja_bleed = /** @type {(inputs: BleedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`塗り足し`)
};

const zh_bleed = /** @type {(inputs: BleedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`出血线`)
};

const ar_bleed = /** @type {(inputs: BleedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`هامش القطع`)
};

const id_bleed = /** @type {(inputs: BleedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bleed (Area Potong)`)
};

const it_bleed = /** @type {(inputs: BleedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abbondanza`)
};

const ru_bleed = /** @type {(inputs: BleedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обрез`)
};

const pt_bleed = /** @type {(inputs: BleedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sangria`)
};

const ko_bleed = /** @type {(inputs: BleedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`재단 여백`)
};

/**
* | output |
* | --- |
* | "Bleed" |
*
* @param {BleedInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const bleed = /** @type {((inputs?: BleedInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<BleedInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_bleed(inputs)
	if (locale === "es") return es_bleed(inputs)
	if (locale === "fr") return fr_bleed(inputs)
	if (locale === "de") return de_bleed(inputs)
	if (locale === "ja") return ja_bleed(inputs)
	if (locale === "zh") return zh_bleed(inputs)
	if (locale === "ar") return ar_bleed(inputs)
	if (locale === "id") return id_bleed(inputs)
	if (locale === "it") return it_bleed(inputs)
	if (locale === "ru") return ru_bleed(inputs)
	if (locale === "pt") return pt_bleed(inputs)
	return ko_bleed(inputs)
});